// new.tsx is unused — the controller auto-creates a draft and redirects to edit.
export default function SoupCampaignsNew() {
  return null
}
